import { useContext } from "react";
import "./MobileMenuHeaderComponent.scss";
import PropTypes from "prop-types";
import { AppContext } from "../../../../contexts/appContext";
import { useNavigate } from "react-router-dom";
import { routesMap } from "../../../../routes";
import { useState } from "react";

/**
 * @function MobileMenuHeaderComponent MobileMenuHeader components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
*/
const MobileMenuHeaderComponent = ({ openMenuHamburger, setOpenMenuHamburger }) => { 

    const { menu } = useContext( AppContext );
    const navigate = useNavigate();   
    const [openSubMenu, setOpenSubMenu] = useState(-1);
    const redirectTo = (id) => {
        if (id === "home") {
            navigate(routesMap.HOME_PAGE);
        }
        else {
            navigate( `${routesMap.DETAGLIO_CATEGORIA}/${id}`);
        }
        closeMenu();
    }

    const closeMenu = () => {
        setOpenMenuHamburger(false);
        closeSubMenu(-1);
    }

    const closeSubMenu = (index) => {
        if (index === -1 || index === openSubMenu)
            setOpenSubMenu(-1);
        else
            setOpenSubMenu(index);
    }


    const renderSubMenuItems = ( voci ) => (   
            voci.map(item => {
                const { nome, idContenuto } = item;
                return (
                    <li className="list-item" key={ nome }>
                        <a onClick={ () => redirectTo(idContenuto) } type="button" role="menuitem" data-bs-toggle="collapse" data-bs-target="#collapseMenu" aria-controls="collapseMenu">
                            <div>{ nome }</div>
                        </a>
                    </li>
                );
            })
    );

    return (
        <div>
            <div className={ openMenuHamburger === false ? "collapse" : "collapse show"} id="collapseMenu">
                <figure className="overlay-wrapper">
                    <figcaption className="overlay-panel overlay-panel-fullheight">
                        <div className="sidebar">
                            <div className="link-list-wrapper" id="accordionMenu">
                                <ul className="link-list">  
                                    <li className="d-grid">
                                        <a className="list-item" type="button" tabIndex="0" onClick={ ()=>closeMenu() } role="button" aria-label="Chiudi menu">
                                            <span className="list-item-title-icon-wrapper sidebar__menuItem--close">
                                                <div className="material-icons-outlined" aria-hidden="true">close</div>
                                            </span>
                                        </a>
                                    </li>
                                    <li className="d-grid">
                                        <button className="list-item sidebar__button d-flex justify-content-left" href="/" onClick={() => redirectTo("home") } tabIndex="0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMenu" aria-controls="collapseMenu">
                                            <span className="list-item-title-icon-wrapper sidebar__menuItem">
                                                <div>Home page</div>
                                            </span>
                                        </button>
                                    </li>
                                    {
                                        menu?.map((item, i) => {
                                            const { tipologia, etichetta, voci } = item;
                                            const ref = "collapse".concat(tipologia);
                                            const href = "#".concat(ref);
                                            return (
                                                <li key={ etichetta } className="d-grid">
                                                    <button className="btn-dropdown list-item sidebar__button d-flex justify-content-left" type="button" onClick={ () => closeSubMenu(i)} data-bs-target={href} data-bs-toggle="collapse" aria-haspopup="true" aria-expanded={ openSubMenu === i ? "true" : "false" } aria-controls={ref}>
                                                        <span className="list-item-title-icon-wrapper sidebar__menuItem">
                                                            {etichetta}
                                                            <div className="icon-expand icon icon-sm material-icons-outlined" aria-hidden="true">expand_more</div>
                                                        </span>
                                                    </button>
                                                    { voci.length >= 1 ? 
                                                    <div id={ref} className={ openSubMenu === i ? "collapse show" : "collapse"} aria-labelledby={ref}>
                                                        <ul className="link-sublist sidebar__subMenuItem">
                                                        { renderSubMenuItems( voci ) }
                                                        </ul>
                                                    </div>
                                                    : <></> }
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </figcaption>
                </figure>
            </div>
        </div>
    );
};

MobileMenuHeaderComponent.propTypes = {
    info: PropTypes.string.isRequired,
};

MobileMenuHeaderComponent.defaultProps = {
    info: "",
};

export default MobileMenuHeaderComponent;